import { Box, Typography } from '@mui/material'

const ChartHeader = (props) => {
    const { chartData = {} } = props
    const bkgTypeList = [
        { name: 'Booked', color: '#FF0000', field: 'bookSeat' },
        { name: 'Booked (Phone)', color: '#FFFF00', field: 'bookSeatPhone' },
        { name: 'Available', color: 'LightGreen', field: 'available' },
        { name: 'Selected', color: '#FFA500', field: 'selectSeat' },

    ]
    return (
        <Box className='chartHeader'>
            {bkgTypeList.map((obj) => (
                <Box className='lableBox'>
                    <Box className='colorBox' sx={{ backgroundColor: obj.color }}></Box>
                    <Typography>{`${obj.name} ${obj.field === 'selectSeat' ? '' : `(${chartData?.[obj.field] || 0})`}`}</Typography>
                </Box>
            ))}
        </Box>
    )
}

export default ChartHeader